/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidv4(),
    index: "I",
    title: "Đối với hoạt động xổ số",
  },
  {
    id: uuidv4(),
    index: "1",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },
  {
    id: uuidv4(),
    title: "Tổng cộng",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },

  {
    id: uuidv4(),
    index: "II",
    title: "Đối với hoạt động đại lý bảo hiểm",
  },
  {
    id: uuidv4(),
    index: "1",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },
  {
    id: uuidv4(),
    title: "Tổng cộng",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },

  {
    id: uuidv4(),
    index: "III",
    title: "Đối với hoạt động trả phí bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác",
  },
  {
    id: uuidv4(),
    index: "1",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },
  {
    id: uuidv4(),
    title: "Tổng cộng",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },

  {
    id: uuidv4(),
    index: "IV",
    title: "Đối với hoạt động bán hàng đa cấp",
  },
  {
    id: uuidv4(),
    index: "1",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },
  {
    id: uuidv4(),
    title: "Tổng cộng",
    value7: "",
    value8: "",
    value9: "",
    value10: 0,
    value11: 0,
    value12: 0,
  },
];

export default function TaxPersonalTable2({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td style={{ textAlign: "center" }}>STT</Td>
              <Td style={{ textAlign: "center" }}>Họ tên cá nhân</Td>
              <Td style={{ textAlign: "center" }}>Mã số thuế cá nhân (MST)</Td>
              <Td style={{ textAlign: "center" }}>
                Số CMND/CCCD/Hộ chiếu(trường hợp cá nhân chưa có MST)
              </Td>
              <Td style={{ textAlign: "center" }}>Doanh thu trong năm</Td>
              <Td style={{ textAlign: "center" }}>Doanh thu thuộc diện khấu trừ thuế trong năm</Td>
              <Td style={{ textAlign: "center" }}>Số thuế đã khấu trừ trong năm</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[06]</Td>
              <Td style={{ textAlign: "center" }}>[07]</Td>
              <Td style={{ textAlign: "center" }}>[08]</Td>
              <Td style={{ textAlign: "center" }}>[09]</Td>
              <Td style={{ textAlign: "center" }}>[10]</Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
            </tr>
            {data.map((item, index) => {
              if ([0, 3, 6, 9].includes(index)) {
                return (
                  <tr key={index}>
                    <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}>
                      {item.index}
                    </Td>
                    <Td
                      colSpan={6}
                      style={{ textAlign: "left", background: "#ddeff3", fontWeight: 700 }}
                    >
                      {item.title}
                    </Td>
                  </tr>
                );
              }
              return (
                <tr key={index}>
                  {item.index ? (
                    <>
                      <Td style={{ textAlign: "center" }}>{item.index}</Td>
                      <Td style={{ textAlign: "center" }}>
                        <InputTable
                          id={item.id}
                          name="value7"
                          type="text"
                          value={item.value7}
                          onChange={handleChange}
                        />
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <InputTable
                          id={item.id}
                          name="value8"
                          type="text"
                          value={item.value8}
                          onChange={handleChange}
                        />
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <InputTable
                          id={item.id}
                          name="value9"
                          type="text"
                          value={item.value9}
                          onChange={handleChange}
                        />
                      </Td>
                    </>
                  ) : (
                    <Td
                      colSpan={4}
                      style={{ textAlign: "left", background: "#ddeff3", fontWeight: 700 }}
                    >
                      {item.title}
                    </Td>
                  )}

                  <Td
                    style={{
                      textAlign: "right",
                      background: !item.index ? "#ddeff3" : "transparent",
                      fontWeight: !item.index ? 700 : 400,
                    }}
                  >
                    {item.index ? (
                      <InputTable
                        id={item.id}
                        name="value10"
                        type="number"
                        value={item.value10}
                        onChange={handleChange}
                      />
                    ) : (
                      0
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: !item.index ? "#ddeff3" : "transparent",
                      fontWeight: !item.index ? 700 : 400,
                    }}
                  >
                    {item.index ? (
                      <InputTable
                        id={item.id}
                        name="value11"
                        type="number"
                        value={item.value11}
                        onChange={handleChange}
                      />
                    ) : (
                      0
                    )}
                  </Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, type, name, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id });
    }
  }
  return (
    <input
      type="text"
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
